import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function InventoryModal({ handleClose, open }) {
  const timelineData = [
    {
      type: 'add',
      quantity: 20,
      time: 20222342323,
    },
    {
      type: 'minus',
      quantity: 20,
      time: 20222342323,
      customerID: 9003,
    },
  ];

  return (
    <div>
      <Dialog open={open} onClose={handleClose} TransitionComponent={Transition}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>

        <Typography align='center'>Vertical Timeline</Typography>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <VerticalTimeline layout="1-column">
            {timelineData.map((item, index) => (
              <VerticalTimelineElement
                key={index}
                date={`Time: ${item.time}`}
                iconStyle={{ background: item.type === 'add' ? 'green' : 'red', color: '#fff' }}
                icon={item.type === 'add' ? '+' : '-'}
                // position={index % 2 === 0 ? 'left' : 'right'}
                position='right'
                style={{ marginLeft: index % 2 === 0 ? '100px' : '0', marginRight: index % 2 === 0 ? '0' : '100px' }}
              >
                <h3 className="vertical-timeline-element-title">
                  {item.type === 'add' ? 'Add Event' : 'Minus Event'}
                </h3>
                <h4 className="vertical-timeline-element-subtitle">{`Quantity: ${item.quantity}`}</h4>
                {item.customerID && <p>{`Customer ID: ${item.customerID}`}</p>}
              </VerticalTimelineElement>
            ))}
          </VerticalTimeline>
        </div>
      </Dialog>
    </div>
  );
}
